import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css']
})
export class EmailComponent implements OnInit {
  emailForm: FormGroup
  success:any=""
  error:any=""
  placeHolder=this.translateService.instant('EmailDialog.Email.PlaceHolder')
  label=this.translateService.instant('EmailDialog.Email.Label')
  emailValid=this.translateService.instant('EmailDialog.Email.Validation.Valid')
  buttonText=this.translateService.instant('EmailDialog.Buttons.Send')
  constructor(
    private translateService:TranslateService,
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<EmailComponent>,
    @Inject(MAT_DIALOG_DATA) { }: any) {
     this. placeHolder=this.translateService.instant('EmailDialog.Email.PlaceHolder')
     this. label=this.translateService.instant('EmailDialog.Email.Label')
     this. emailValid=this.translateService.instant('EmailDialog.Email.Validation.Valid')
     this. buttonText=this.translateService.instant('EmailDialog.Buttons.Send')
    }

  @Output()
  sendEmailClicked: EventEmitter<any> = new EventEmitter<any>();
  ngOnInit(): void {
    this.emailForm = this.formBuilder.group({
      EmailAddress: ['', Validators.compose([Validators.email, Validators.required])]
    });
  }

  sendEmail() {
    this.sendEmailClicked.emit(this.emailForm);
    
  }

  close() {
    this.dialogRef.close();
  }
}
